import { get } from 'lodash'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export function blockCampaign(store, campaignId, is_p2p_enabled) {
  const state = store.getState()
  const campaign = get(state, `campaign.${campaignId}`, {})

  // block all GN/GNC from P2P flow and p2p flow when enabled
  if (!is_p2p_enabled || campaign.campaign_type === CROWD_FUNDING) {
    return true
  }
  return !(
    get(campaign, 'can_donate', true) && get(campaign, 'can_chip_in', true)
  )
}

export function hasSendChildRoute(childRoutes, pathname) {
  return childRoutes.some(childRoute => {
    return pathname.includes(childRoute)
  })
}
